import Cross from './Cross';
import Pin from './Pin';

export default {
	cross: {
		anchorPoint: [0.5, 0.5],
		component: Cross,
	},
	pin: {
		anchorPoint: [0.5, 1],
		component: Pin,
	},
};
